import { storyblokEditable, StoryblokRichText } from "@storyblok/react";
import "./blog/blog-post.css";
import { Breadcrumb } from "./Breadcrumb";
import { FooterBuffer } from "./FooterBuffer";


const BlogResource = ({ blok }) => {
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display">
        <div className="container herosub blogresource">
          {/* <Breadcrumb currentName={blok.title} /> */}
          <h1>{blok.title}</h1>
          <date>{blok.published_at}</date>
        </div>
        <div className="font-display text-left blog-content">
          <div className="blog-summary">
            <h2>{blok.summary}</h2>
          </div>
          <div className="featured-image">
            <img
              src={blok.featuredimage.filename}
              alt={blok.featuredimage.alt}
            />
          </div>
          <div
            className="blog-content-main">
          <StoryblokRichText doc={blok.maincontent}/>
          </div>
          
        </div>
          
      </div>

      <FooterBuffer />
    </>
  );
};

export default BlogResource;
